import { call, put, takeLatest } from 'redux-saga/effects';

import { videosAddItemRequest, videosDeleteItemRequest, videosUpdateError, videosUpdateItemRequest, videosUpdateRequest, videosUpdateStore } from './videosActions.js';
import { addVideosItemApiCall, deleteVideosItemApiCall, updateVideosBlockApiCall, updateVideosItemApiCall } from './videosAPI.js';

function* updateVideosSaga({ payload }) {
  try {
    yield call(updateVideosBlockApiCall, payload);
    yield put(videosUpdateStore());
  } catch (error) {
    yield put(videosUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* addVideosItemSaga({ payload }) {
  try {
    yield call(addVideosItemApiCall, payload);
    yield put(videosUpdateStore());
  } catch (error) {
    yield put(videosUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* updateVideosItemSaga({ payload }) {
  try {
    const { id, ...data } = payload;
    yield call(updateVideosItemApiCall, id, data);
    yield put(videosUpdateStore());
  } catch (error) {
    yield put(videosUpdateError(error.Message ? error.Message : error.toString()));
  }
}

function* deleteVideosItemSaga({ payload }) {
  try {
    yield call(deleteVideosItemApiCall, payload);
    yield put(videosUpdateStore());
  } catch (error) {
    yield put(videosUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsVideosWatcher() {
  yield takeLatest(videosUpdateRequest.type, updateVideosSaga);
  yield takeLatest(videosAddItemRequest.type, addVideosItemSaga);
  yield takeLatest(videosUpdateItemRequest.type, updateVideosItemSaga);
  yield takeLatest(videosDeleteItemRequest.type, deleteVideosItemSaga);
}
